export const colors =  {
    primary : '#eee',

    button: {
        disable : 'gray',
    }
};